module.exports = "/static/assets/0c8f529bb6607606374003ef056226d7.png";